const Strings = {
  MRP: "MRP",
  DISCOUNT: "DISCOUNT",
  GST: "SGST+CGST+CESS",
  MORE_PRICE: "OUR PRICE",
  QUANTITY: "QUANTITY",
  TOTAL_PRICE: "TOTAL PRICE",
  MORE_POINTS_EARNED: "more+ POINTS DISCOUNT",
  MORE_PLUS_POINTS_EARNED: "more+ POINTS EARNED",
  TOTAL_MORE_PLUS_POINTS_EARNED: "TOTAL more+ POINTS EARNED",
  RECEIPT: "RECEIPT",
  CUSTOMER: "CUSTOMER",
  STORE: "STORE",
  GSTIN: "GSTIN",
  FSSAI_LICENSE_NO: "FSSAI LICENSE NO.",
  ITEMS: "ITEMS",
  DISCOUNTS: "DISCOUNTS",
  MORE_POINTS: "more+ POINTS DISCOUNT",
  GRAND_TOTAL: "GRAND TOTAL",
  VIEW_ALL_ITEMS: "VIEW ALL ITEMS",
  DOWNLOAD_INVOICE: "DOWNLOAD TAX INVOICE",
  TERMS: "Terms",
  PRIVACY: "Privacy",
  REFUNDS: "Refunds",
  DIAMOND: "diamond",
  GET_MORE_PLUS: " Get more+ diamond now & save 5% extra on every order",
  SAVINGS: "savings",
  THIS_ORDER: "This Order",
  LIFETIME: "Lifetime",
  NO_DATA_AVAILABLE: "No Data Available",
  PLEASE_TRY_LATER: "Unable to fetch receipt details. Please try again later.",
  MORE_PLUS_POINTS: " more+ points",
  HSN: "HSN",
  CIN: "CIN",
  GST_BREAKDOWN: "GST BREAKDOWN",
  PAYMENT_METHODS: "PAYMENT METHODS",
  STORE_DETAILS: "STORE DETAILS",
  ADDRESS: "ADDRESS",
  CONTACT: "CONTACT",
  CUSTOMER_DETAILS: "CUSTOMER DETAILS",
  LOGIN: "Log In",
  COMPLETE_YOUR_PROFILE: "complete your profile",
  USER_DETAILS: "userDetails",
  HEY_THERE: "hey there!",
  LINK_EXPIRED: "Uh oh! Your link seems to have expired.",
  LOGIN_IN_WITH_NUMBER:
    "Log in with your registered phone number to view all your orders.",
  EDIT_PROFILE: "edit profile",
  OTP: "OTP",
  YOUR_MORE_MARKET: "your super– market",
  GET_MORE_LIFE: "Get more of life with more",
  TERMS_AND_PRIVACY: "Terms & Privacy",
  VERIFY: "verify",
  START_SHOPPING_FOR_ORDERS:
    "Start shopping now to see all your beautiful orders here.",
  ALL_ORDERS: "All Orders",
  LOG_OUT: "Log Out",
};

export default Strings;
